var isDev = process.env.NODE_ENV === "development";
var apiBaseFromEnv = process.env.REACT_APP_API_BASE;
var domain_backend = apiBaseFromEnv || (isDev ? "http://localhost:8000/api" : window.location.origin + "/api");

export { domain_backend }